import $ from 'jquery';
import balanceText from 'balance-text';
import * as Vibrant from 'node-vibrant';
import PhotoSwipeLightbox from 'photoswipe/lightbox';


let $w = $(window);
let homeSlider;
let colour, thumb;
let wait = false;
let started = false;

function l(m) { console.log(m); }

function checkCookie() {
    // l('check cookie');
    if (document.cookie.indexOf('cookie-note=1') !== -1) {
        $('.cookie').addClass('gone');
    } else {
        $('.cookie').removeClass('gone');
    }

    if (document.cookie.indexOf('cookie-form=1') !== -1) {
        $('.overlay').addClass('gone');
    } else {
        $('.overlay').removeClass('gone');
    }
}

function initSlider() {
    l('initSlider');
    const lightbox = new PhotoSwipeLightbox({
      gallery: '#film_gallery',
      children: 'a',
      pswpModule: () => import('photoswipe')
    });
    lightbox.init();
}


// Site Object
class Site {

    init() {
        l('Site by Post 📫');
        l('www.workbypost.com');
        checkCookie();
        balanceText();
        if ($('body').hasClass('home')) {
            l('home');
            site.homeSlider();
            site.staggerReveal('.quarters_quarter', 150);
            setTimeout(() => {
                site.staggerReveal('.reellink', 150);
            }, 1000);
        } else if ($('body').hasClass('project')) {
            l('project')
            var thumb = $('.main').data('thumb');
            site.bgColorFromImage(thumb);
            site.revealNav();
        // } else if ($('body').hasClass('category')) {

        } else {
            site.setBgColor(colour);
            site.revealNav();
        }

        if ($('body').hasClass('film')) {
            l('film page');
            initSlider()
        }

        if ($('body').hasClass('work') || $('body').hasClass('category')) {
            l('work or category page');
            setTimeout(() => {
                site.staggerReveal('.projects_thumb', 150);
            }, 500);
        }

        if ($('body').hasClass('agency')) {
            setInterval(() => {
                site.changeProfiles('.slides');
            }, 1800);
        }

    }

    changeProfiles(el) {
        $(el).each(function () {
            if ($(this).children().length > 1) {

                let $slides = $(this).find('.slide.active');
                // l(;
                if ($slides.next().length == 0) {
                    // get first one if is last item
                    $slides.removeClass('active');
                    $(this).children().first().addClass('active');
                } else {
                    // get next
                    $slides.removeClass('active').next().addClass('active');
                }
            }
        });
    }

    trans() {
        balanceText();
        $('html, body').animate({ scrollTop: 0 }, 300);
        if (!$('body').hasClass('project')) {
            site.setBgColor(colour);
        }
        if ($('body').hasClass('home')) {
            // site.revealShowreel(0);
            site.hideNav();
            l('home');
            site.homeSlider();
            site.staggerReveal('.quarters_quarter', 150);
            setTimeout(() => {
                site.staggerReveal('.reellink', 150);
            }, 1000);
        } else {
            site.showNav();
        }
        if(window.location.pathname.indexOf('/category/') > -1) {
            let navClass = '.category-' + window.location.pathname.split('/category/')[1];
            $(navClass).addClass('active');
        } else {
            site.clearNav();
        }
        
        if ($('body').hasClass('film')) {
            l('film page');
            initSlider()
        }

        if ($('body').hasClass('agency')) {
            setInterval(() => {
                site.changeProfiles('.slides');
            }, 1800);
        }
    }

    filmButtons() {
        if ($('body').hasClass('film')) {
           console.log(document.documentElement.scrollTop); 
           if(document.documentElement.scrollTop > window.innerHeight/2) {
            $('.film_bottomnav, .film_bottomdownload').addClass('in');
           } else {
            $('.film_bottomnav, .film_bottomdownload').removeClass('in');
           }
        }
    }

    clearNav() {
        $('.header a').removeClass('active');
    }

    setBgColor(colour) {
        if (colour) {
            $(".main").css({
                background: colour
            });
        } else {
            var colour = $(".main").data('color');
            $(".main").css({
                background: colour
            });
        }
    }

    hideNav() {
        $('.left').addClass('hide');
        $('.right').addClass('hide');
    }

    showNav() {
        $('.left').removeClass('hide');
        $('.right').removeClass('hide');
    }

    homeFadeInSequence() {
        // console.log('homeFadeInSequence');
        site.revealHomeElements();
        // if maintenance mode isnt on show the nav and showreel
        if ($('.maintenance').length !== 1) {
            // show nav and showreel
            site.staggerReveal('nav ul li a.out', 150);
            setTimeout(() => {
                site.revealShowreel(1500);
            }, 4000);

            started = true;
        }
    }

    revealHomeElements() {
        site.reveal('.logo');
        site.reveal('.maintenance');
        site.reveal('.footer');
    }

    revealNav() {
        site.reveal('.logo');
        site.staggerReveal('nav ul li a.out', 150);
        site.reveal('.footer');
    }


    reveal(selector, delay) {
        let d;
        if (delay !== undefined) {
            d = delay;
        } else {
            d = 0;
        }
        setTimeout(() => {
            $(selector).removeClass('out');
        }, d);
    }

    staggerReveal(selector, offset) {
        $(selector).each((index, item) => {
            let el = item;
            setTimeout(that => {
                $(that).removeClass('out');
            }, offset * index, el);
        });
    }

    revealShowreel(delay) {
        setTimeout(() => {
            $('.showreel.out').removeClass('out');
            $('.maintenance').addClass('out');
            $('.crisp, .blur').addClass('out');
        }, delay);
    }

    loadPage(page) {
        $.ajax(page, {
            beforeSend: function () {
                $(".main").addClass("out");
            },
            success: function (data) {
                setTimeout(function () {
                    const contents = $(data)
                        .filter(".main")
                        .children();
                    colour = $(data).filter(".main").data('color');
                    thumb = $(data).filter(".main").data('thumb');
                    $(".main").html(contents);
                    site.updateTitle(data);
                    site.updateBody(data);

                    setTimeout(function (colour) {
                        site.trans();
                        $(".main").removeClass("out");
                    }, 400);
                }, 100);
            },
            error: function () {
                console.log("error");
            }
        });
    }

    homeSlider() {
        clearInterval(homeSlider);
        homeSlider = setInterval(function () {
            if (!$('.crisp').hasClass('out')) {
                if ($('.crisp .active').is(':last-child')) {
                    $('.crisp .active').removeClass('active');
                    $('.crisp li:first-child').addClass('active');
                } else {
                    $('.crisp .active').removeClass('active').next().addClass('active');
                }
            }

            if (!$('.blur').hasClass('out')) {
                if ($('.blur .active').is(':last-child')) {
                    $('.blur .active').removeClass('active');
                    $('.blur li:first-child').addClass('active');
                } else {
                    $('.blur .active').removeClass('active').next().addClass('active');
                }
            }

            if (!started) {
                site.homeFadeInSequence();
            }

        }, 350);
    }

    updateTitle(html) {
        document.title = html.match(/<title>(.*?)<\/title>/)[1].trim();
    }

    updateBody(html) {
        let pageClass = html.match(/<body class="(.*?)">/)[1].trim();
        $('body').removeClass().addClass(pageClass);
    }

    ajax(e) {
        if (
            this.href.indexOf(document.domain) > -1 ||
            this.href.indexOf(":") === -1
        ) {
            // newUrl = this.href.split('.')[0].split('0/')[1];
            history.pushState({}, "", this.href);
            e.preventDefault();
            
            if($('.reel').hasClass('active')) {
                $('.reel').removeClass('active');
            } else {
                site.loadPage(this.href);
                if ($(this).hasClass('t_nav')) {
                    $('header.header a.active').removeClass('active');
                    $(this).addClass('active');
                }
            }
        }
    }

    toggler(e) {
        e.preventDefault();
        let $b = $('body'),
            toggle = e.data.class;
        // l(toggle);
        if ($b.hasClass(toggle)) {
            $b.removeClass(toggle);
        } else {
            $b.addClass(toggle);
        }
    }

    addClass(e) {
        e.preventDefault();
        let $b = $('body'),
            toggle = e.data.class;
        $b.addClass(toggle);
    }

    removeClass(e) {
        e.preventDefault();
        let $b = $('body'),
            toggle = e.data.class;
        $b.removeClass(toggle);
    }

    scrollToContent(event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: $('a.down').offset().top + 150 }, 300);
    }

    workElementRollover(event) {
        if (event.type == 'mouseenter') {
            if ($('.hoverimage')) {
                var imgUrl = $(this).parent().parent().data('thumb');
                if (imgUrl !== 'not set') {

                    // update bg color
                    site.bgColorFromImage(imgUrl);

                    // switch out image
                    var newImg = $('<img class="out" style="display: block;">');
                    newImg.attr('src', imgUrl);
                    newImg.appendTo('.hoverimage');
                    setTimeout(() => $(newImg).removeClass('out'), 200);

                }
            }
        } else {
            // on mouseleave remove image
            var oldImg = $('.hoverimage img');
            oldImg.addClass('out');
            setTimeout(() => oldImg.remove(), 300);

        }
    }

    bgColorFromImage(image) {
        // l(image);
        // Vibrant.from(image).getPalette((err, palette) => console.log(palette))
        Vibrant.from(image).getPalette((err, palette) => {
            delete palette.Muted;
            delete palette.LightMuted;
            delete palette.Vibrant;
            let noOfColours = Object.keys(palette).length - 1;
            var tone = Object.keys(palette)[Math.floor(Math.random() * noOfColours)];
            // console.log(tone);
            $('.main').css({
                background: palette[tone].hex
            });
        });
    }
    // logMouse(event) {
    //     console.log('The mouse is currently at (' + event.pageX + ',' + event.pageY + ')');
    // }
    // setBlurLevel() {
    //     if ($('body').hasClass('work') || $('body').hasClass('label')) {
    //         if (!wait) {
    //             // site.logMouse(event);
    //             let center = 0.5,
    //                 mousePos = event.clientX / $w.width(),
    //                 mouseFromCenter = mousePos - center,
    //                 blurAmount = 100,
    //                 blur = blurAmount;

    //             if (Math.sign(mouseFromCenter) == -1) {
    //                 blur = (Math.sign(mousePos - 0.45) == -1) ? Math.floor(Math.abs(mousePos - 0.45) * (blurAmount * 2)) : 0;
    //             } else {
    //                 blur = (Math.sign(mousePos - 0.55) == 1) ? Math.floor(Math.abs(mousePos - 0.55) * (blurAmount * 2)) : 0;
    //             }

    //             let blurCSS = 'blur(' + blur + 'px)';

    //             if ($('.adr')) {
    //                 $('.adr').css({
    //                     filter: blurCSS
    //                 });
    //             }
    //             if ($('.hoverimage')) {
    //                 $('.hoverimage').css({
    //                     filter: blurCSS
    //                 });
    //             }

    //             wait = true;
    //             setTimeout(function () { wait = false; }, 20);
    //         }
    //     }
    // }
    prevent(e) {
        e.preventDefault();
    }
}

export default Site;